module.exports = __webpack_public_path__ + "static/img/aa.f69513c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa.png
// module id = /soT
// module chunks = 0